export const maxDisabledValue = 50;


export const sentimentType = {
    NEGATIVE: "negative",
    POSITIVE: "positive",
};
